// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"8c122bc3","419":"387c9655","669":"f779f4e9","833":"687b00e2"}[chunkId] + ".chunk.js";
};